import { render } from "./TheCustomerFormPage.vue?vue&type=template&id=b6324b02"
import script from "./TheCustomerFormPage.vue?vue&type=script&lang=js"
export * from "./TheCustomerFormPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__